/**
 * Returns a function, that, when invoked, will only be triggered at most once during
 * a given window of time.
 * @param {Function} fn - Callback function.
 * @param {number} [wait=300] - Time window (in milliseconds).
 * @returns {Function}
 */
/**
 * Throttle util
 */
function throttle(fn, wait = 300) {
  let throttleTimeoutId = -1;
  let tick = false;

  return () => {
    clearTimeout(throttleTimeoutId);
    throttleTimeoutId = setTimeout(fn, wait);

    if (!tick) {
      fn.call();
      tick = true;
      setTimeout(() => { tick = false; }, wait);
    }
  };
}

if (!customElements.get('sticky-atc')) {
  customElements.whenDefined('product-form').then(() => {
    class StickyAtc extends customElements.get('product-form') {
      constructor() {
        super();

        // 🔐 Null-safe lookups
        this.section = this.closest('.section-main-product') ||
                       document.querySelector('.section-main-product') ||
                       document; // fallback para no romper

        this.mainProductForm = this.section.querySelector('product-form') || null;
        this.mainProductSubmitForm = this.mainProductForm?.getSubmitForm?.() || null;

        this.submitForm = this.getSubmitForm?.() || null;
        this.buyButtons = this.section.querySelector('buy-buttons') || null;
        this.imageContainer = this.querySelector('.sticky-atc__image') || null;
        this.variantTitle = this.querySelector('.sticky-atc__details__variant__title') || null;
        this.variantTitle?.toggleAttribute('hidden', !this.section.querySelector('variant-picker'));
        this.button = this.querySelector('.add-to-cart') || null;

        this.throttledOnScroll = throttle(this.handleScroll.bind(this));
        window.addEventListener('scroll', this.throttledOnScroll, { passive: true });

        // Si la galería no emite, no pasa nada
        this.section.addEventListener?.('on:media-gallery:change', this.updateImage.bind(this));

        this.updateImage();
        this.updateAddToCartButton();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.throttledOnScroll);
      }

      /**
       * Submit del formulario
       */
      async handleSubmit(evt) {
        evt.preventDefault();

        const idInput = this.section.querySelector('.js-product-form input[name="id"]');
        const variantId = idInput?.value;

        if (!variantId) {
          const target = this.section.querySelector('#product-info');
          if (target && target.offsetParent) {
            evt.preventDefault();
            // theme.* puede no existir en algunos temas → null-safe
            window.theme?.scrollToRevealElement?.(target);
          }
          return;
        }

        // Validación del form principal
        const customFormValid = this.mainProductForm?.validate?.() ?? true;
        const reportOk = this.mainProductSubmitForm?.reportValidity?.() ?? true;

        if (!customFormValid || !reportOk) {
          evt.preventDefault();
          if (!customFormValid) {
            window.theme?.scrollToRevealElement?.(this.mainProductForm);
          } else {
            const input = Array.from(this.mainProductSubmitForm?.elements || []).find(
              (el) => !el.checkValidity?.()
            );
            if (input) setTimeout(() => window.theme?.scrollToRevealElement?.(input), 100);
          }
          return;
        }

        // Limpiar campos copiados
        this.submitForm?.querySelectorAll?.('[data-copied]')?.forEach((el) => el.remove());

        // Copiar datos del form principal al sticky
        if (this.mainProductSubmitForm && this.submitForm) {
          const formData = new FormData(this.mainProductSubmitForm);
          for (const p of formData) {
            if (!this.submitForm.querySelector(`[name="${p[0]}"]`)) {
              const input = document.createElement('input');
              input.name = p[0];
              input.value = p[1];
              input.hidden = true;
              input.setAttribute('data-copied', '');
              this.submitForm.append(input);
            }
          }
        }

        // Llamar al comportamiento por defecto solo si existe
        if (super.handleSubmit) {
          super.handleSubmit(evt);
        }
      }

      /**
       * Visibilidad tras scroll
       */
      handleScroll() {
        // Si falta el contenedor de botones, no podemos calcular → salimos sin error
        if (!this.buyButtons) return;

        const header = document.querySelector('.pageheader--sticky')
          ? document.querySelector('.section-header')
          : null;
        const topOffset = header?.offsetHeight || 0;

        // 🔐 getBoundingClientRect null-safe
        const rect = (typeof this.buyButtons.getBoundingClientRect === 'function')
          ? this.buyButtons.getBoundingClientRect()
          : null;
        if (!rect) return;

        this.classList.toggle('sticky-atc--out', rect.bottom > topOffset);

        document.body.classList.toggle(
          'scrolled-to-bottom',
          window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
        );
      }

      /**
       * Actualiza imagen
       */
      updateImage() {
        const mainImage = this.section.querySelector(
          '.media-gallery .main-image .slider__item.is-active .product-media img'
        );

        if (this.imageContainer) {
          if (mainImage) {
            this.imageContainer.innerHTML = mainImage.outerHTML;
          } else {
            this.imageContainer.textContent = '';
          }
        }
      }

      /**
       * Actualiza texto del botón ATC
       */
      updateAddToCartButton() {
        if (!this.button) return;
        const idInput = this.section.querySelector('.js-product-form input[name="id"]');
        const variantId = idInput?.value;
        if (!variantId) {
          this.button.innerHTML = this.button.dataset.unavailableText || this.button.innerHTML;
        }
      }
    }

    customElements.define('sticky-atc', StickyAtc);
  });
}
